import {
  ApiBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import {
  discoveryApiRef,
  fetchApiRef,
  githubAuthApiRef,
} from '@backstage/core-plugin-api';
import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';
import { rithumAgentApiRef } from './RithumAgentApi';
import { DefaultRithumAgentClient } from './DefaultRithumAgentClient';
import { RithumAgentRootWrapper } from './RithumAgentRootWrapper';

const rithumAgentRootWrapper = AppRootWrapperBlueprint.make({
  name: 'rithum-agent',
  params: {
    component: RithumAgentRootWrapper,
  },
});

const rithumAgentApi = ApiBlueprint.make({
  name: 'rithum-agent',
  params: params =>
    params({
      api: rithumAgentApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        githubAuthApi: githubAuthApiRef,
      },
      factory: ({ discoveryApi, fetchApi, githubAuthApi }) =>
        new DefaultRithumAgentClient(discoveryApi, fetchApi, githubAuthApi),
    }),
});

export const rithumAgentAppModule = createFrontendModule({
  pluginId: 'app',
  extensions: [rithumAgentRootWrapper, rithumAgentApi],
});
